import * as React from "react";
import { useIntl } from "@grandvisionhq/state";
import SkipToMapLink from "./SkipToMapLink.js";
const SkipToMapLinkContainer = ({ mapId, ...rest }) => {
  const { getLabel } = useIntl();
  const onClick = (event) => {
    event.preventDefault();
    document.getElementById(mapId)?.querySelector('[tabindex="0"]')?.focus();
  };
  return /* @__PURE__ */ React.createElement(
    SkipToMapLink,
    {
      ...rest,
      href: `#${mapId}`,
      onClick,
      text: getLabel("stores.page.search.skipToMapLink")
    }
  );
};
export {
  SkipToMapLinkContainer as default
};
//# sourceMappingURL=SkipToMapLinkContainer.js.map
